"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ModalManager = /** @class */ (function () {
    function ModalManager() {
        this.modals = [];
        this.styleRestore = new Map();
    }
    // TODO does the modal manager need to take care of locking body scolling
    ModalManager.prototype.addModal = function (modal) {
        if (!modal) {
            return;
        }
        var modalIndex = this.modals.indexOf(modal);
        // If already added, don't add again
        if (modalIndex >= 0) {
            return;
        }
        // Disable scrolling if `modal` is about to be the first opened modal
        if (this.modals.length === 0) {
            this.disableScrolling();
        }
        this.modals.push(modal);
    };
    ModalManager.prototype.removeModal = function (modal) {
        if (!modal) {
            return;
        }
        var modalIndex = this.modals.indexOf(modal);
        // If not found, return
        if (modalIndex === -1) {
            return;
        }
        // Remove the overlay
        this.modals.splice(modalIndex, 1);
        // If there are no more modals on screen, reenable scrolling
        if (this.modals.length === 0) {
            this.enableScrolling();
        }
    };
    ModalManager.prototype.isOverlayOnTop = function (overlay) {
        var numOverlays = this.modals.length;
        return numOverlays > 0 && this.modals[numOverlays - 1] === overlay;
    };
    ModalManager.prototype.disableScrolling = function () {
        var element = document.body;
        var scrollbarWidthPx = window.innerWidth - element.clientWidth;
        // PADDING
        // Make a note of the current padding so it can be restored later
        this.styleRestore.set("padding-right", element.style.paddingRight);
        var currentPaddingPx = parseInt(window.getComputedStyle(element).paddingRight) || 0;
        // Add padding to make up for the scrollbar about to be hidden
        element.style.paddingRight = scrollbarWidthPx + currentPaddingPx + "px";
        // OVERFLOW
        // Make a note of the current overflow setting so it can be restored later
        this.styleRestore.set("overflow", element.style.overflow);
        element.style.overflow = "hidden";
    };
    ModalManager.prototype.enableScrolling = function () {
        var element = document.body;
        // PADDING
        element.style.paddingRight = this.styleRestore.get("padding-right");
        // OVERFLOW
        element.style.overflow = this.styleRestore.get("overflow");
    };
    return ModalManager;
}());
exports.default = ModalManager;
//# sourceMappingURL=ModalManager.js.map